<template>
  <div class="compass-wrapper">
    <img :src="require('@/assets/images/generic/compass.svg')"  class="compass-circle">
    <img :src="require('@/assets/images/generic/compass-needle.svg')"  class="compass-needle" :style="`transform: rotate(${degrees}deg)`">
  </div>
</template>

<script>
export default {
  props: ['degrees']

}
</script>

<style lang="scss">

.compass-wrapper {
  .compass-circle {
    width: 140px;
    position: absolute;
    top: -5px;
    right: 0;
  }
  .compass-needle {
    width: 140px;
    position: absolute;
    top: -5px;
    right: 0;
  }
}

</style>